<template lang="pug">
  svg(viewBox="0 0 14 14", fill="none", :class="{ referral }")
    path(d="M9 9.69589C8.66815 11.5733 7.01715 13 5.03039 13C2.80447 13 1 11.2091 1 9C1 6.79086 2.80447 5 5.03039 5C6.83505 5 8.36269 6.17716 8.87627 7.8", stroke-width="1.4", stroke-linecap="round")
    path(d="M5 4.2C5.37436 2.37421 7.00487 1 8.95959 1C11.191 1 13 2.79086 13 5C13 7.20914 11.191 9 8.95959 9C7.15044 9 5.619 7.82284 5.10415 6.2", stroke="#19A2DC", stroke-width="1.4", stroke-linecap="round")
</template>

<script>
export default {
  props: {
    referral: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/variables';

  svg {
    width: 14px;
    height: 14px;

    path {
      stroke: $blue;
      fill: none;
    }

    &.referral path { stroke: $orange-3 !important; }
  }

</style>
